<div *ngIf="formGroup" class="body" [class.invalid]="formGroup.invalid">

    <div class="content-wrapper">

        <div *ngIf="isDefaultNotificationControl.value" class="badge predefined">
            Vordefiniert
        </div>
    
        <div class="subject" [class.no-value]="!subjectControl.value">
            {{subjectControl.value? subjectControl.value: 'kein Betreff'}}
        </div>
    
        <ng-container *ngIf="receiverControl.value; else noReceiver">
    
            <ng-container *ngIf="typeControl.value">
    
                <div class="type">
                    {{subTitle}}
                </div>
        
            </ng-container>
    
        </ng-container>

        <div class="attachements" [formGroup]="formGroup" *ngIf="typeControl.value === NotificationTaskType.EMail">

            <app-attachement-preview></app-attachement-preview>

        </div>

    </div>

    <div class="controls">

        <button mat-icon-button color="warn" (click)="delete()">
            <mat-icon>delete_forever</mat-icon>
        </button>

    </div>

</div>

<ng-template #noReceiver>

    <div class="missing-receiver-hint">

        <mat-icon class="icon">warning</mat-icon>

        <div class="text-wrapper">
            
            <div class="headline">
                Kein Empfänger angegeben
            </div>

            <span class="sub-title">
                Nachrichten ohne Empfänger werden nicht versendet und auch in der Zusammenfassung ignoriert
            </span>

        </div>

    </div>

</ng-template>